<template>
  <section class="form-underwriting width-700">
    <el-form
      ref="form"
      :rules="rules"
      class="form-container"
      :model="formData">
      <div class="form-item form-half">
        <span>Studying Country</span>
        <el-form-item
          prop="country_id">
          <v-select
            v-model="formData.country_id"
            :list="localAllOptions.study_country" />
        </el-form-item>

        <!--        <el-form-item-->
        <!--          v-if="formData.country_id==3"-->
        <!--          class="margin-top"-->
        <!--          prop="other_country">-->
        <!--          <v-input-->
        <!--            v-model="formData.other_country"-->
        <!--          />-->
        <!--        </el-form-item>-->
      </div>
      <div class="form-item form-half">
        <span>Student Age</span>
        <el-form-item
          prop="student_age">
          <v-input
            v-model="formData.student_age"
            keyNumber/>
        </el-form-item>
      </div>
      <div class="form-item form-half">
        <span>Studying Full-time?</span>
        <el-form-item
          prop="is_full_time">
          <v-radio-group
            v-model="formData.is_full_time"
            :list="yesNoOptions" />
        </el-form-item>
      </div>
      <!-- <div class="form-item">
        <span>Plan Level</span>
        <el-form-item
          prop="plan_tier"
        >
          <v-radio-group
            v-model="formData.plan_tier"
            :border="true"
            :list="planLevelOptions"
          />
        </el-form-item>
      </div> -->
    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
export default {
  name: 'FormUnderwriting',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const checkStudentAge = (rule, value, callback) => {
      let {student_age} = this.formData
      var reg = /^[1234567890]*$/
      if(!value||value<7||value>70||value && !reg.test(value)) {
        callback(new Error(this.$t('只能輸入7-70')))
      }
      callback()
    }
    return {
      formData: {
        // class_id: 25,
        country_id: '',
        // other_country: '',
        is_full_time: '',
        student_age:'',
        plan_tier: 0
      },
      extraRules: {
        student_age:[
          { validator: checkStudentAge, trigger: ['blur','change'] }
        ]
      }
    }
  },
  computed: {
    localAllOptions() {
      return this.allOptions25
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        Object.keys(this.formData).some(key => {
          if(key in val) {
            this.formData[key] = val[key]
          }
        })
      }
    }
  },
  methods: {
    submitForm() {
      // 表單校驗
      this.$refs.form.validate(valid => {
        if(valid) {
          this.$emit('getFormData', {
            ...this.formData,
            class_id: 25
          })
        }
      })

    }
  }
}
</script>
<style lang="scss" scoped>
.form-underwriting {
  position: relative;
  // width: 700px;
}
  .margin-top{
    margin-top: 10px;
  }
</style>
